module.exports = __webpack_public_path__ + "assets/img/softwareAA.4b9b6e3b.png";